import { ScreenshotLegendPlacement } from "../models/enums/screenshot-legend-placement";

export interface PostVenueRoomCommand {
  roomName: string;
  maxCapacity: number;
  distanceBetweenChairsInches: number;
  allowsChandeliers: boolean;
  displayIconLegendInScreenshots: boolean;
  screenshotLegendPlacement: ScreenshotLegendPlacement;
}

export interface PostVenueAdminVenueCommand {
  phone: string;
  email: string;
  website: string;
  market: string;
  setting: string;
  style: string;
  type: string;
  notificationsEmail: string;
}

export interface PostVenueTemplateNameCommand {
  templateName: string;
  templateId: string;
}

export interface PostVenueTemplateDeactivateCommand {
  templateId: string;
}

export interface PostVenueItemQuantityCommand {
  quantity: number;
}

export class VenueAdminCommands {
  static getPostVenueRoomCommand(
    roomName: string,
    maxCapacity: number,
    distanceBetweenChairsInches: number,
    allowsChandeliers: boolean,
    displayIconLegendInScreenshots: boolean,
    screenshotLegendPlacement: ScreenshotLegendPlacement,
  ): PostVenueRoomCommand {
    return {
      roomName: roomName,
      maxCapacity: maxCapacity,
      allowsChandeliers: allowsChandeliers,
      distanceBetweenChairsInches: distanceBetweenChairsInches,
      displayIconLegendInScreenshots: displayIconLegendInScreenshots,
      screenshotLegendPlacement: displayIconLegendInScreenshots ? screenshotLegendPlacement : null,
    };
  }

  static getPostVenueTemplateNameCommand(templateId: string, templateName: string): PostVenueTemplateNameCommand {
    return {
      templateId: templateId,
      templateName: templateName,
    };
  }

  static getPostVenueTemplateDeactivateCommmand(templateId: string): PostVenueTemplateDeactivateCommand {
    return {
      templateId: templateId,
    };
  }

  static getPostVenueAdminVenueCommand(
    phone: string,
    email: string,
    website: string,
    market: string,
    setting: string,
    style: string,
    type: string,
    notificationsEmail: string,
  ): PostVenueAdminVenueCommand {
    return {
      phone: phone,
      email: email,
      website: website,
      market: market,
      setting: setting,
      style: style,
      type: type,
      notificationsEmail: notificationsEmail,
    };
  }

  static getPostVenueItemQuantityCommand(quantity: number): PostVenueItemQuantityCommand {
    return {
      quantity: quantity,
    };
  }
}
